export default __webpack_public_path__ + "static/media/insta.b2b0db91.svg";